import { Collapse, Grid } from '@material-ui/core';
import React from 'react';
import { generateLabel } from '../../../../utils/helpers';
import CustomTextField from '../../../CustomTextField';

type Props = {
  isActive: boolean;
  handleChangeClient: ({
    target: { name, value, checked },
  }: React.ChangeEvent<HTMLInputElement>) => void;
  validationErrors: any;
  username: string;
  password: string;
  client_id: string;
  apiToken: string;
  companyCode: string;
  vendor: string;
  propertyCode: string;
};

const YardiAttributes: React.FC<Props> = props => {
  const {
    isActive,
    handleChangeClient,
    username,
    password,
    client_id,
    apiToken,
    companyCode,
    vendor,
    propertyCode,
  } = props;

  return (
    <Collapse in={isActive}>
      <Grid container spacing={4}>
        <Grid item xs={12} sm={6}>
          <CustomTextField
            margin="normal"
            fullWidth
            label={generateLabel('Yardi Username')}
            name="Yardi Username"
            value={username || ''}
            onChange={handleChangeClient}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <CustomTextField
            margin="normal"
            fullWidth
            label={generateLabel('Yardi Password')}
            name="Yardi Password"
            value={password || ''}
            onChange={handleChangeClient}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <CustomTextField
            margin="normal"
            fullWidth
            label={generateLabel('Yardi Client Id')}
            name="Yardi Client Id"
            value={client_id || ''}
            onChange={handleChangeClient}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <CustomTextField
            margin="normal"
            fullWidth
            label={generateLabel('Yardi API Token')}
            name="Yardi API Token"
            value={apiToken || ''}
            onChange={handleChangeClient}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <CustomTextField
            margin="normal"
            fullWidth
            label={generateLabel('Yardi Company Code')}
            name="Yardi Company Code"
            value={companyCode || ''}
            onChange={handleChangeClient}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <CustomTextField
            margin="normal"
            fullWidth
            label={generateLabel('Yardi Vendor')}
            name="Yardi Vendor"
            value={vendor || ''}
            onChange={handleChangeClient}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <CustomTextField
            margin="normal"
            fullWidth
            label={generateLabel('Yardi Property Code')}
            name="Yardi Property Code"
            value={propertyCode || ''}
            onChange={handleChangeClient}
          />
        </Grid>
      </Grid>
    </Collapse>
  );
};

export default React.memo(YardiAttributes);
